import React, { useState } from "react";
import "./CreatePlan.scss";
import Input from "../../../components/atoms/Input/Input";
import Button from "../../../components/atoms/Button/Button";
import { validateData } from "../../../utiles/ValidateEntries";
import { toast, Toaster } from "sonner";
import { plan } from "../../../services/plan";
import ValidationMessage from "../../../components/atoms/ValidationMessage/ValidationMessage";

const CreatePlan = ({ setClose, getPlans }) => {
    const [newPlan, setNewPlan] = useState({
        name: "",
        cost: "",
        deviceCount: "",
    });

    const [emptyField, setEmptyField] = useState({});

    const eventChange = (e) => {
        const { name, value } = e.target;
        setNewPlan((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleCreate = async (e) => {
        e.preventDefault();

        // Validación de datos
        const { status, emptyFields } = validateData(newPlan);
        setEmptyField(emptyFields);

        if (!status) {
            console.error("Por favor, completa todos los campos requeridos.");
            return;
        }

        const toastId = toast.loading("Procesando...");

        try {
            const payload = {
                ...newPlan,
                cost: `${parseFloat(newPlan.cost || 0).toFixed(2)}`,
            };

            const response = await plan.create(payload);
            const { success, message, requestCode } = response;

            if (!success) {
                throw new Error(message || "Error al crear el plan");
            }

            if (requestCode === 201) {
                toast.success("Éxito", {
                    description: message || "Plan creado correctamente",
                    icon: "🎉",
                    position: "top-right",
                    duration: 5000,
                    id: toastId,
                });

                // Recargar la lista de planes
                if (getPlans) {
                    getPlans();
                }

                // Cerrar el modal después de 2 segundos
                setTimeout(() => setClose(false), 2000);
            }
        } catch (error) {
            toast.error("¡Ups...!", {
                description: error.message,
                position: "top-right",
                duration: 5000,
                icon: "😞",
                id: toastId,
            });
        }
    };

    return (
        <form className="create-plan" onSubmit={handleCreate}>
            <div className="create-plan__form-group">
                <ValidationMessage show={emptyField.name}>
                    <Input
                        text="Nombre del plan"
                        name="name"
                        show={emptyField.name}
                        onChange={eventChange}
                        placeholder="Ej: Plan Premium"
                    />
                </ValidationMessage>
            </div>

            <div className="create-plan__form-group">
                <ValidationMessage show={emptyField.cost}>
                    <Input
                        text="Costo del plan"
                        name="cost"
                        show={emptyField.cost}
                        onChange={eventChange}
                        placeholder="Ej: 99.99"
                        type="number"
                        step="0.01"
                    />
                </ValidationMessage>
            </div>

            <div className="create-plan__form-group">
                <ValidationMessage show={emptyField.deviceCount}>
                    <Input
                        text="Número de dispositivos"
                        type="number"
                        name="deviceCount"
                        show={emptyField.deviceCount}
                        onChange={eventChange}
                        placeholder="Ej: 5"
                    />
                </ValidationMessage>
            </div>

            <div className="create-plan__form-actions">
                <Button
                    text="Cancelar"
                    type="button"
                    onClick={() => setClose(false)}
                />
                <Button text="Guardar" className="degrad" type="submit" />
            </div>

            <Toaster />
        </form>
    );
};

export default CreatePlan;
